import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Pagination from "@material-ui/lab/Pagination";

import { getChunk } from "../src/utils/firebase";

import Video from "./Video";
import VideoStableDuel from "./VideoStableDuel";
import VideoAlt from "./VideoAlt";

function VideoFeedPaginated({
  classes,
  title,
  user,
  tag,
  columns,
  variant,
  stableduel,
}) {
  const limit = 24;
  const pages = 10;
  const chunk = limit * pages;

  const [currentPage, setCurrentPage] = useState(1);
  const [paginationCount, setPaginationCount] = useState(0);
  const [lastOfChunk, setLastOfChunk] = useState(null);
  const [loading, setLoading] = useState(false);
  const [endReached, setEndReached] = useState(false);

  let selector;
  if (user) {
    selector = { type: "user", filter: user };
  } else if (tag) {
    selector = { type: "tag", filter: tag };
  }

  const [allVideos, setAllVideos] = useState([]);
  const [paginatedResults, setPaginatedResults] = useState([]);

  useEffect(() => {
    // once last chunk is reached, fetch next chunk
    if (!endReached && allVideos.length <= currentPage * limit) {
      let fetchVideos = async () => {
        setLoading(true);
        let result = await getChunk(chunk, lastOfChunk, selector);
        if (result?.chunkedResults.length < chunk) {
          setEndReached(true);
        }
        setLastOfChunk(result.lastResultRef);
        setAllVideos([...allVideos, ...result.chunkedResults]);
        setPaginationCount(
          paginationCount + Math.floor(result.chunkedResults.length / limit)
        );
        setLoading(false);
      };
      fetchVideos();
    }
    paginateResults(allVideos);
  }, [currentPage, allVideos]);

  // slice results into sets of "limit"
  const paginateResults = (arr) => {
    const begin = (currentPage - 1) * limit;
    const end = begin + limit;

    let list = arr.slice(begin, end);
    setPaginatedResults(list);
  };

  // while traversing up through the pages, only ever increment pagination count by one page at a time
  // this helps to keep firestore queries to a minimum
  const handleChange = (event, value) => {
    setCurrentPage(value);
  };

  // last page, this is needed to avoid a blank page at end
  if (currentPage > 1 && paginatedResults.length === 0) {
    return (
      <div className={classes.allFeedsContainer}>
          <div className={classes.feedRoot}>
            <Typography variant="h6" className={classes.feedTitle}>
              Recent Videos
            </Typography>
            <Typography variant="h6" className={classes.feedTitle}>You've reached the end!</Typography>
            <br />
            {paginationCount > 0 && (
              <Pagination
                count={paginationCount}
                page={currentPage}
                onChange={handleChange}
              />
            )}
          </div>
      </div>
    )
  }

  return (
    <div className={classes.feedRoot}>
      <Typography
        variant="h6"
        className={stableduel ? classes.sdFeedTitle : classes.feedTitle}
      >
        {title}
      </Typography>
      {loading && (
        <Typography variant="h6" className={classes.feedTitle}>
          Loading Feed...
        </Typography>
      )}
      <Grid container spacing={3}>
        {allVideos && allVideos.length == 0 && (
          <p className={classes.emptyFeedText}>
            {user && "This user hasn't uploaded anything yet."}
            {tag && "There are no videos for this tag yet."}
          </p>
        )}

        {paginatedResults?.map((feedItem, i) => (
          <Grid
            item
            xs={columns || 12}
            sm={columns || 6}
            md={columns || 3}
            key={i}
          >
            {stableduel ? (
              <VideoStableDuel flex video={feedItem} />
            ) : (
              <>
                {variant === "alt" ? (
                  <VideoAlt flex video={feedItem} />
                ) : (
                  <Video flex video={feedItem} />
                )}
              </>
            )}
          </Grid>
        ))}
      </Grid>
      <br />
      {allVideos && paginationCount > 0 && (
        <Pagination
          count={paginationCount}
          page={currentPage}
          onChange={handleChange}
        />
      )}
    </div>
  );
}

export default VideoFeedPaginated;
